import { render, staticRenderFns } from "./SocialWallPostItem.vue?vue&type=template&id=1c19c0ac&scoped=true"
import script from "./SocialWallPostItem.vue?vue&type=script&lang=js"
export * from "./SocialWallPostItem.vue?vue&type=script&lang=js"
import style0 from "./SocialWallPostItem.vue?vue&type=style&index=0&id=1c19c0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c19c0ac",
  null
  
)

export default component.exports